module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("BATTLE "), _c('span', {
    staticClass: "half1"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "titled"
  }, [_vm._v("BRITAIN")]), _vm._v(" "), _c('span', {
    staticClass: "titledd"
  }, [_vm._v("1940")])]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE FINEST HOUR’S HUMAN COST")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Dilip Sarkar MBE FRHistS")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76de0eda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Title.vue
// module id = 63
// module chunks = 0